import { useQuery } from '@tanstack/react-query';
import Product from 'classes/Product';
import productService from 'v2/services/product';

export const useProduct = (id: number, ignoreActiveAffiliates = false) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['product', id, ignoreActiveAffiliates],
    queryFn: async () => {
      const productResult = await productService.loadProductById(id, ignoreActiveAffiliates);

      if (!productResult.data) {
        return null;
      }

      return new Product(productResult.data);
    },
    enabled: id > 0,
    staleTime: 2 * 60 * 1000
  });

  return {
    product: data,
    isLoading: id > 0 && isLoading,
    error
  };
};
